import { INSTANCE_PVTD_READ_META } from 'client/redux/pvtd/constants';
import * as actionCreators from 'client/redux/pvtd/actionCreators';

export const instancePvtdReadMeta = id => dispatch => {
  return dispatch(actionCreators.instancePvtdReadMeta(INSTANCE_PVTD_READ_META, id));
};

